export default __webpack_public_path__ + "static/media/icons_badge_success.ecad7d29.svg";